import React from 'react';
import { ROUTES } from '../constants/routes';
import { Route, Routes } from 'react-router-dom';
import { LoginWrapper } from '../pages/Login/LoginWrapper';
import { Register } from '../pages/register';
import '../styles/index.scss';

export const PublicApp = () => {
    return (
        <Routes>
            <Route path={ROUTES.login} element={<LoginWrapper />} />
            <Route path={ROUTES.register} element={<Register />} />
            <Route path="*" element={<LoginWrapper />} />
        </Routes>
    );
};
